import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import { ApiService as api } from "../../services/ApiService";
import { useSession } from "../../hooks/useSession";

export const useConfermaPrenotazionePage = () => {
    const navigate = useNavigate();
    const { read, batchUpdate, update } = useSession();
    const { state } = useLocation();
    const { slotFrom, slotTo, date, isLastDate } = state;
    const [booked, setBooked] = useState(false);
    const [posto, setPosto] = useState("");
    const [busy, setBusy] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");
    const opensInInterval = useRef(null);
    const nextAllowedBookingRequestAt = useRef(0);

    useEffect(() => {
        opensInInterval.current = setInterval(() => {
            if (isLastDate) {
                setDisabled(moment().toDate().getTime() < read("opensIn"));
                if (moment().toDate().getTime() >= read("opensIn")) clearInterval(opensInInterval.current);
            } else {
                setDisabled(false);
                clearInterval(opensInInterval.current);
            }
        }, 100);
        return () => {
            clearInterval(opensInInterval.current);
        };
    }, []);

    const back = () => {
        navigate(-1);
    };

    const bookNow = async () => {
        if (busy || disabled) return;

        try {
            const waitBeforeRequest = Math.max(0, nextAllowedBookingRequestAt.current - Date.now());
            if (waitBeforeRequest) {
                setBusy(true);
                await new Promise((resolve) => setTimeout(resolve, waitBeforeRequest));
            }

            let toastMessage = "";
            setErrorMessage(toastMessage);
            setBusy(true);
            const _date = moment(date);
            const payload = {
                UserId: read("userId"),
                ClassePostoAuto: "1",
                DataPrenotazione: `${_date.format("YYYY-MM-DD")} ${slotFrom.toString().padStart(5, "0")}:00`,
                DataFinePrenotazione: `${_date.format("YYYY-MM-DD")} ${slotTo.toString().padStart(5, "0")}:00`,
            };
            if (read("key")) payload["key"] = read("key");

            const bookRes = await api.Prenotazione(payload);

            nextAllowedBookingRequestAt.current = Date.now() + (bookRes.waitTime || 0);
            if (bookRes.key) update("key", bookRes.key);

            if (bookRes.result) {
                setPosto(bookRes.postoAutoAssegnato);
                setBooked(true);
                batchUpdate({
                    selectedDate: null,
                    selectedSlot: null,
                    postoAutoAssegnato: bookRes.postoAutoAssegnato,
                });
            } else {
                toastMessage = bookRes.message || "Prenotazione non riuscita. Riprova";
                setErrorMessage(toastMessage);
            }
            setBusy(false);
        } catch (error) {
            setErrorMessage("Prenotazione non riuscita. Riprova");
            setBusy(false);
        }
    };

    return {
        bookNow,
        back,
        slotFrom,
        slotTo,
        date,
        booked,
        posto,
        busy,
        disabled,
        errorMessage,
    };
};
